<template>
  <div class="mx-2">
    <Slider v-model="range"
            :min="min"
            :max="max"
            :step="step"
            :format="format"
            class="slider-green"
            @update="onUpdate"
    />
    <div class="d-flex flex-row justify-content-between pt-3">
      <input v-model="range[0]"
             class="form-control input-white w-25"
             @input="onUpdateMin"
      >
      <input v-model="range[1]"
             class="form-control input-white w-25"
             @input="onUpdateMax"
      >
    </div>
  </div>
</template>

<!-- Composition API is neeeded for Vue <= 2.6 https://github.com/vueform/slider/tree/2.0.10#using-with-vue-2 -->
<script>
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

import Slider from '@vueform/slider/dist/slider.vue2.js'

export default {
  name: "range_slider",
  props: ['filter'],
  components: {
    Slider,
  },
  data() {
    return {
      range: Object.keys(this.filter.rangeTotal).map((key) => {
        return this.filter.rangeTotal[key]
      }),
      min: this.filter.rangeTotal['min'],
      max: this.filter.rangeTotal['max'],
      step: 1,
      format: {
        suffix: '',
        decimals: 0
      }
    }
  },
  created() {
    this.range[0] = this.filter.rangeSelected['min']
    this.range[1] = this.filter.rangeSelected['max']

    if (this.filter.rangeDecimals > 0) {
      this.format.decimals = this.filter.rangeDecimals
      this.step = -1
    }

    if (this.filter.rangeUnit) {
      this.format.suffix = ' ' + this.filter.rangeUnit
    }
  },
  methods: {
    onUpdate() {
      this.range[0] = this.range[0].toFixed(this.format.decimals)
      this.range[1] = this.range[1].toFixed(this.format.decimals)

      this.filter.value = {
        min: this.range[0],
        max: this.range[1]
      }
    },
    onUpdateMin(e) {
      e.target.value = parseFloat(e.target.value.replace(",", ".")).toFixed(this.format.decimals);

      if (e.target.value < this.filter.rangeTotal['min']) {
        e.target.value = this.filter.rangeTotal['min']
      }

      this.filter.value = {
        min: e.target.value,
        max: this.range[1]
      }
    },
    onUpdateMax(e) {
      e.target.value = parseFloat(e.target.value.replace(",", ".")).toFixed(this.format.decimals);

      if (e.target.value > this.filter.rangeTotal['max']) {
        e.target.value = this.filter.rangeTotal['max']
      }

      this.filter.value = {
        min: this.range[0],
        max: e.target.value
      }
    }
  }
}
</script>

<style scoped>
.slider-green {
  --slider-connect-bg: #25A738;
  --slider-tooltip-bg: #25A738;
  --slider-handle-ring-color: #25A738;
}
</style>

<style src="@vueform/slider/themes/default.css"></style>